<i class="spinner fa fa-circle-o-notch fa-spin fa-3x fa-fw"></i>
<img
  #_img
  [class]="_class"
  [title]="_title"
  [alt]="_alt"
  (load)="_loaded(true)"
  [src]="_src"
/>
